import { stdin } from 'node:process';
import React from 'react';
import { isType } from 'variant';
import { createFsCache, CacheState } from '@wix/cli-fs-cache';
import { render, renderSync } from '@wix/cli-ui-kit';
import { I18nProvider } from '@wix/cli-i18n';
import { UserFeedbackForm } from './components/UserFeedback/Form.js';
import { UserFeedbackFallback } from './components/UserFeedback/Fallback.js';
import { ReportErrorResult } from './error-reporter.js';
import type { ErrorReporter } from './error-reporter.js';
import messages from './messages.json' with { type: 'json' };

interface Options {
  cachePath: string | undefined;
  errorReporter: ErrorReporter;
  reportResult: ReportErrorResult;
}

export async function collectUserFeedback({
  cachePath,
  reportResult,
  errorReporter,
}: Options) {
  if (
    !stdin.isTTY ||
    !cachePath ||
    !isType(reportResult, ReportErrorResult.Reported)
  ) {
    return;
  }

  const fsCache = createFsCache({
    filePath: cachePath,
    ttlInHours: 1,
  });
  const cacheState = await fsCache.get();

  if (isType(cacheState, CacheState.Exists)) {
    return;
  }

  const user = errorReporter.getUser();

  if (user) {
    await render(
      <I18nProvider messages={messages}>
        <UserFeedbackForm
          onSubmit={({ feedback }) => {
            void errorReporter.reportUserFeedback({
              userId: user.id,
              eventId: reportResult.eventId,
              feedback,
            });
          }}
        />
      </I18nProvider>
    );
  } else {
    renderSync(
      <I18nProvider messages={messages}>
        <UserFeedbackFallback />
      </I18nProvider>
    );
  }

  await fsCache.set({ reported: true });
}
